import { Box, BoxProps, styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

type ProjectChipProps = Omit<BoxProps, 'children'> & {
  projectName: string;
  icon?: React.ReactNode; // Accepts MUI SVG icons
};

export const ProjectChip = styled(
  ({ projectName, icon, ...props }: ProjectChipProps) => (
    <Box {...props}>
      {icon && <span style={{ marginRight: 3 }}>{icon}</span>}
      {projectName}
    </Box>
  ),
  {
    overridesResolver: removeTheseProps<ProjectChipProps>(
      'projectName',
      'icon',
    ),
  },
)({
  display: 'flex',
  alignItems: 'center',
  height: 'min-content',
  width: 'fit-content',
  padding: '2px 8px',
  fontSize: 11,
  color: '#202227',
  border: '1px solid #828D98',
  borderRadius: '12px',
  backgroundColor: '#E8EAEC',
});
